import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the contacts menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  ldFlags: object
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getBusinessOperationsMenu({ businessEntityUuid, ldFlags, order }) {
  const { releaseZbContactsPhase1Milestone1 } = ldFlags;

  if (!releaseZbContactsPhase1Milestone1) {
    return {};
  }

  return processMenu({
    title: 'Contacts',
    itemId: 'contacts',
    icon: 'contact-page.svg',
    path: generatePath(ROUTES.entityClients, { businessEntityUuid }),
    order
  });
}
